import React from "react";
import RoundButton from "../../../Common/RoundButton";

export default function KycExistsForm({
  handleDashboard
}: any) {
  return (
    <>
      <h5>Show Details to user with CKYC</h5>
      <div style={{ marginTop: "20%" }}>
        <RoundButton onClick={handleDashboard} title="Goto Dashboard" />
      </div>
    </>
  );
}
